const BASE_URL: string = process.env.REACT_APP_API_KEY || '';
// const BASE_URL: string = 'http://178.128.61.122:8086';

//notification
export const FIND_MANY_ADVERTISE = BASE_URL + '/advertise/advertise/find-many';
export const CREATE_ADVERTISE = BASE_URL + '/advertise/advertise/create';
export const DELETE_ADVERTISE = BASE_URL + '/advertise/advertise/delete?id=';

//banner
export const FIND_MANY_BANNER = BASE_URL + '/advertise/banner/find-many-slide';
export const BANNER_URL = BASE_URL;
export const CREATE_BANNER = BASE_URL + '/advertise/banner/create-slide';
export const UPDATE_BANNER = BASE_URL + '/advertise/banner/update?id=';

//banner promotion
export const FIND_MANY_BANNER_PROMOTION_AND_COUPON =
  BASE_URL + '/advertise/banner-promotion-and-coupon/find-many';
export const CREATE_BANNER_PROMOTION =
  BASE_URL + '/advertise/banner-promotion-and-coupon/create-banner-promotion';
export const UPDATE_BANNER_PROMOTION =
  BASE_URL + '/advertise/banner-promotion-and-coupon/update-banner-promotion?id=';
export const CREATE_BANNER_COUPON =
  BASE_URL + '/advertise/banner-promotion-and-coupon/create-banner-coupon';
export const UPDATE_BANNER_COUPON =
  BASE_URL + '/advertise/banner-promotion-and-coupon/update-banner-coupon?id=';

//popup
export const FIND_MANY_POPUP = BASE_URL + '/advertise/popups/find-many';
export const CREATE_POPUP = BASE_URL + '/advertise/popups/create';
export const UPDATE_POPUP = BASE_URL + '/advertise/popups/update?id=';
export const DELETE_POPUP = BASE_URL + '/advertise/popups/delete?id=';
